import {management} from '../../../../index.js' //api

async function updateVolumeInput({VALUE, FK_VALVE, FK_SECTOR, TIME}) {
  const rawUpdate = `
    UPDATE CROP.VOLUME
    SET VALUE_INPUT = ${VALUE}
    WHERE (
      FK_VALVE = ${FK_VALVE}
      AND FK_SECTOR = ${FK_SECTOR}
      AND TIME = '${TIME}'
    );  
  `;

  const rawInsert = `
    INSERT INTO CROP.VOLUME ( FK_VALVE, FK_SECTOR, TIME, VALUE, VALUE_INPUT)
    VALUES ( ${FK_VALVE}, ${FK_SECTOR}, '${TIME}', 0, ${VALUE} );  
  `;

  const rawSelect = `
    SELECT *
    FROM CROP.VOLUME
    WHERE (
        FK_VALVE = ${FK_VALVE}
        AND FK_SECTOR = ${FK_SECTOR}
        AND TIME = '${TIME}'
      ) 
  `;

  const mustCreateVolumeLog = await management.sql({
    data: {
      sql: rawSelect
    }
  })
  .then(resp => resp && resp[0] ? resp[0] && !resp[0][0] : false)

  let runningQuery = rawUpdate;

  if(mustCreateVolumeLog) {
    runningQuery = rawInsert;
  }
  
  return await management.sql({
    data: {
      sql: runningQuery
    }
  })
  .then(resp => resp && resp[0] ? resp[0] : [])
  .catch(err => {
    console.log("deu erro ao atualizar o volume", err)
    return {err}
  })
}

export {
  updateVolumeInput
};